// LevelEditor.js
import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import axiosInstance from 'utils/axiosInstance';

const defaultRequirements = Array.from({ length: 19 }, (_, i) => 10 * Math.pow(2, i));

const generateDynamicMinMaxStep = (requirements) => {
  return requirements.map((_, i) => {
    const step = i < 5 ? 5 : i < 10 ? 10 : 100;
    const min = i === 0 ? 10 : requirements[i - 1];
    const max = 20 * Math.pow(2, i+1);
    return { min, max, step };
  });
};


const LevelEditor = ({ myInfoProfile }) => {
  const [requirements, setRequirements] = useState([...defaultRequirements]);
  const [isSaving, setIsSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (
      myInfoProfile &&
      Array.isArray(myInfoProfile.levelRequirements) &&
      myInfoProfile.levelRequirements.length === 19
    ) {
      setRequirements([...myInfoProfile.levelRequirements]);
    }
  }, [myInfoProfile]);

  const handleChange = (index, newValue) => {
    const updated = [...requirements];
    const value = Number(newValue);

    // Update current level
    updated[index] = value;

    // Ensure all subsequent levels are >= current
    for (let i = index + 1; i < updated.length; i++) {
      if (updated[i] < updated[i - 1]) {
        updated[i] = updated[i - 1];
      }
    }

    setRequirements(updated);
    setSuccess(false);
    setError(null);
  };

  const handleReset = () => {
    setRequirements([...defaultRequirements]);
    setSuccess(false);
    setError(null);
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      setError(null);
      await axiosInstance.put(`/knovia/myInfo/userInfoProfile/levelRequirements`, {
        levelRequirements: requirements
      });
      setSuccess(true);
    } catch (err) {
      console.error('Save failed:', err);
      setError('Failed to save changes.');
    } finally {
      setIsSaving(false);
    }
  };

  const minMaxPerLevel = generateDynamicMinMaxStep(requirements);
  const cumulativeXP = requirements.reduce((acc, val, i) => {
    acc.push((acc[i - 1] || 0) + val);
    return acc;
  }, []);

  return (
    <div className="level-editor-container">
      {requirements.map((xp, i) => (
        <div key={i} className="level-row">
          <div className="level-header">
            <span className="level-label">Level {i + 1} ➝ {i + 2}</span>
            <span className="level-xp">{xp} XP</span>
          </div>
          <input
            type="range"
            min={minMaxPerLevel[i].min}
            max={minMaxPerLevel[i].max}
            step={minMaxPerLevel[i].step}
            value={xp}
            onChange={(e) => handleChange(i, e.target.value)}
            className="level-slider"
          />
          <div className="level-total">
            到達 level {i + 2} 總 XP: {cumulativeXP[i]}
          </div>
        </div>
      ))}

      {success && (
        <div className="success-message">
          更新成功！
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="level-actions">
        <Button
          onClick={handleSave}
          disabled={isSaving}
          color="success"
          className="action-button"
        >
          {isSaving ? '更新中...' : '更新經驗值'}
        </Button>

        <Button
          onClick={handleReset}
          disabled={isSaving}
          color="secondary"
          className="action-button"
        >
          重設數值
        </Button>
      </div>

    </div>
  );
};

export default LevelEditor;


